<template> <!-- Template is expected to be inside a <sui-table> with 2 columns -->
    <sui-table-body>
        <sui-table-row>
            <sui-table-header-cell>
                Port-data
            </sui-table-header-cell>
            <sui-table-cell>
                <span v-if="apiResponse">{{toUserFriendlyTimestamp(apiResponse.headers.date, true, false)}}</span> 
                <sui-button v-if="includeReloadBtn" size="mini" @click.prevent="getNexelData" style="float: right"><i class="fas fa-sync" v-bind:class="{'fa-spin': dataLoading}"></i></sui-button>
            </sui-table-cell>
        </sui-table-row>
        <template v-if="apiResponse">    
            <sui-table-row>
                <sui-table-cell>InstallationsNr</sui-table-cell>
                <sui-table-cell>
                    {{apiResponse.id}}
                </sui-table-cell>
            </sui-table-row>
            <sui-table-row>
                <sui-table-cell>{{ apiResponse.capabilities?.technology?.toUpperCase() == 'PON' ? 'ISAM' : 'ASR' }}</sui-table-cell>
                <sui-table-cell>
                    <span v-if="apiResponse.fqdn">{{apiResponse.fqdn.replace('.energifyn.net', '')}}</span>
                </sui-table-cell>
            </sui-table-row>
            <sui-table-row>
                <sui-table-cell>Port</sui-table-cell>
                <sui-table-cell>{{apiResponse.port}}</sui-table-cell>
            </sui-table-row>
            <sui-table-row>
                <sui-table-header-cell colspan="2">Capabilities</sui-table-header-cell>
            </sui-table-row>
            <template v-if="apiResponse.capabilities">
                <sui-table-row v-for="key of Object.keys(apiResponse.capabilities)" :key="key">
                    <sui-table-cell>
                        <span v-if="key == 'cpeSerial' && apiResponse.capabilities.technology.toUpperCase() != 'PON'">Mac-adresse</span>
                        <span v-else-if="apiResponse.capabilities.technology.toUpperCase() == 'PON'">{{ camelCaseToSentence(key).replaceAll(/(cpe)/gi, 'ONT') }}</span>
                        <span v-else>{{camelCaseToSentence(key).replaceAll(/(cpe)/gi, 'CPE')}}</span>
                    </sui-table-cell>
                    <sui-table-cell>
                        <span v-if="key == 'cpeSerial' && apiResponse.capabilities.technology.toUpperCase() != 'PON'">{{formatMacAdress(apiResponse.capabilities[key])}}</span>
                        <span v-else-if="key == 'technology'">{{ apiResponse.capabilities[key].toUpperCase() }}</span>
                        <span v-else-if="typeof apiResponse.capabilities[key] === 'boolean'">
                            <i v-if="apiResponse.capabilities[key]" class="fas fa-check" style="color: green;"></i>
                            <i v-else class="fas fa-times" style="color: red;"></i>
                        </span>
                        <span v-else>{{apiResponse.capabilities[key]}}</span>
                    </sui-table-cell>
                </sui-table-row>
            </template>
        </template>
        <template v-if="apiError && apiError.errorObject">
            <sui-table-row>
                <sui-table-cell colspan="2" style="color: red;">
                    Fejl ved hentning af data: {{apiError.errorObject.message || 'Ukendt fejl'}}
                </sui-table-cell>
            </sui-table-row>
            <!-- <sui-table-row v-for="key in Object.keys(apiError.errorObject)" :key="key">
                <sui-table-cell>{{ key }}</sui-table-cell>
                <sui-table-cell>{{apiError.errorObject[key]}}</sui-table-cell>
            </sui-table-row> -->
            <sui-table-row> <!-- Error code explanations -->
                <sui-table-cell colspan="2" v-if="apiError.errorObject.status == '403'">
                    Fejl 403 betyder at vores API-nøgle ikke har tilladelse til at hente Nexel-status for denne installation.
                </sui-table-cell>
                <sui-table-cell colspan="2" v-else-if="apiError.errorObject.status == '404'">
                    Fejl 404 betyder at installationsnummeret ikke blev fundet ikke i Nexel-databasen.
                </sui-table-cell>
                <sui-table-cell colspan="2" v-else-if="apiError.errorObject.status == '500'">
                    Fejl 500 betyder at der er en intern serverfejl hos PilotBI/VirkPlan. Prøv igen senere.
                </sui-table-cell>
            </sui-table-row>
        </template>
    </sui-table-body>
</template>

<script>
import { Mixin } from '../../lib/Mixins/mixin'
import { DateMixin } from '../../lib/Mixins/dateMixin'
import { DataAPI } from '../../lib/DataAPI'
import EventBus from '../../EventBus'

export default {
    mixins: [Mixin, DateMixin, DataAPI],

    components: {
        // TableLoader,
    },

    props: {
        instLabel: String,
        includeReloadBtn: Boolean,
    },

    data(){
        return {
            dataLoading: false,
            apiResponse: null,
            apiError: null,
        }
    },

    methods: {
        async getNexelData() {
            EventBus.$emit('function-activity', {functionName: 'NexelData_getNexelData', isActive: true})
            this.apiResponse = null
            this.apiError = null
            EventBus.$emit('retrieved-nexel-data', {data: 'Henter data...', loading: true})
            if (!this.instLabel) {
                EventBus.$emit('retrieved-nexel-data', {data: 'Intet installations-nr', loading: false})
                EventBus.$emit('function-activity', {functionName: 'NexelData_getNexelData', isActive: false})
                return null
            }
            this.dataLoading = true
            try {
                this.apiResponse = await this.dataGetNexelData(this.instLabel)
                EventBus.$emit('retrieved-nexel-data', {data: this.apiResponse.id, loading: false})
                this.dataLoading = false
            } catch (error) {
                EventBus.$emit('retrieved-nexel-data', {data: 'Kunne ikke hente data!', loading: false})
                console.error(error)
                this.apiError = error
                this.dataLoading = false
            }
            EventBus.$emit('function-activity', {functionName: 'NexelData_getNexelData', isActive: false})
            return this.apiResponse
        },

        formatMacAdress(macAdress) {
            if (!macAdress) return null
            macAdress = macAdress.toUpperCase().match(/([A-Z0-9])/g).join('') //Removes any special characters
            macAdress = macAdress.match(/.{1,2}/g).join(':') //Inserts colons in the right places
            return macAdress
        },
    },

    mounted() {
        EventBus.$on('reload-nexel-data-click', () => {this.getNexelData()})
    },

    beforeDestroy() {
        EventBus.$off('reload-nexel-data-click')
    },

    watch: {
        instLabel: {
            immediate: true,
            handler() {
                this.getNexelData()
            }
        }
    }
}
</script>